import axios, { AxiosRequestConfig } from 'axios';
import { PagedResponse } from '../types/api';
import { SitterTeachingSkill } from '../types/SitterTeachingSkill';

const URL = '/v2/sitter-teaching-skills';

class SitterTeachingSkillsService {
  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<SitterTeachingSkill>> {
    return axios.get(URL, config);
  }

  static create(data: SitterTeachingSkill, config?: AxiosRequestConfig): Promise<SitterTeachingSkill> {
    return axios.post(URL, data, config);
  }

  static delete(id: number, config?: AxiosRequestConfig): Promise<unknown> {
    return axios.delete(`${URL}/${id}`, config);
  }
}

export { SitterTeachingSkillsService };
